import { Text } from "../ui/text";

const AiAgentNotEnoughCredit = () => {
  return (
    <div
      className="border border-red-20 rounded-[8px] px-4 py-[10px] flex gap-[24px]"
      style={{
        background: "#FFFFFF",
        width: "724px",
        height: "101px",
      }}
    >
      <div className="flex items-center">
        <div className="flex items-center justify-center w-[40px] h-[40px]">
          <img
            src="/images/not-enough-credit-icon.svg"
            alt="not-enough-credit"
            width={27.2}
            height={40}
          />
        </div>
      </div>
      <div>
        <Text variant="title-md" className="text-grey-20">
          Not enough credit
        </Text>{" "}
        <br />
        <Text variant="body-light" className="text-grey-20">
          To purchase more credits, contact our Sales Team.
        </Text>{" "}
        <br />
        <Text variant="body-light" className="text-primary-20 underline">
          contact@cellkey.co.kr
        </Text>
      </div>
    </div>
  );
};

export default AiAgentNotEnoughCredit;
